import { require200Status } from "../../utils/response.js";
import { transformAccessToken } from "../../../utils/response.js";
function oauthEndpoints(builder) {
  return {
    login: builder.mutation({
      invalidatesTags: ["self"],
      query: ({ grant_type = "password", ...body }) => ({
        url: "/oauth/access_token",
        method: "POST",
        body: {
          grant_type,
          ...body
        },
        validateStatus: require200Status
      }),
      transformResponse: (response) => {
        return transformAccessToken(response);
      }
    })
  };
}
export {
  oauthEndpoints as default
};
